import { Feature, InjectorService } from '@tencent/workbench';
import BaseDrawerEffectFeature from '@framework/workbench/common/feature/base-drawer-effect-feature';
import { INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import { ISoftEdgeShower } from '@tencent/drawing-drawer-components';
import { SoftEdgeFeature } from '@framework/workbench/drawer/ui/effects/soft-edge/soft-edge-feature';

@Feature()
export class SoftEdgeShower extends BaseDrawerEffectFeature implements ISoftEdgeShower {
    private softEdgeFeature: SoftEdgeFeature;
    public constructor() {
        super();
        this.softEdgeFeature = InjectorService.get(SoftEdgeFeature);
    }

    public getSoftEdgeSize = () => this.getShownValue(
        INPUT_PROPS_CALLBACK_KEY.SOFT_EDGE,
        { size: this.softEdgeFeature.size },
    );
}
